export enum Cardinality16D {
  N = 'N',
  NNE = 'NNE',
  NE = 'NE',
  ENE = 'ENE',
  E = 'E',
  ESE = 'ESE',
  SE = 'SE',
  SSE = 'SSE',
  S = 'S',
  SSW = 'SSW',
  SW = 'SW',
  WSW = 'WSW',
  W = 'W',
  WNW = 'WNW',
  NW = 'NW',
  NNW = 'NNW'
}

export namespace Cardinality16D {
  export function getArray(): Cardinality16D[] {
    return [
      Cardinality16D.N,
      Cardinality16D.NNE,
      Cardinality16D.NE,
      Cardinality16D.ENE,
      Cardinality16D.E,
      Cardinality16D.ESE,
      Cardinality16D.SE,
      Cardinality16D.SSE,
      Cardinality16D.S,
      Cardinality16D.SSW,
      Cardinality16D.SW,
      Cardinality16D.WSW,
      Cardinality16D.W,
      Cardinality16D.WNW,
      Cardinality16D.NW,
      Cardinality16D.NNW
    ]
  }

  export function getTable() {
    return [
      { name: 'N', min: 348.75, max: 360 },
      { name: 'N', min: 0, max: 11.25 },
      { name: 'NNE', min: 11.25, max: 33.75 },
      { name: 'NE', min: 33.75, max: 56.25 },
      { name: 'ENE', min: 56.25, max: 78.75 },
      { name: 'E', min: 78.75, max: 101.25 },
      { name: 'ESE', min: 101.25, max: 123.75 },
      { name: 'SE', min: 123.75, max: 146.25 },
      { name: 'SSE', min: 146.25, max: 168.75 },
      { name: 'S', min: 168.75, max: 191.25 },
      { name: 'SSW', min: 191.25, max: 213.75 },
      { name: 'SW', min: 213.75, max: 236.25 },
      { name: 'WSW', min: 236.25, max: 258.75 },
      { name: 'W', min: 258.75, max: 281.25 },
      { name: 'WNW', min: 281.25, max: 303.75 },
      { name: 'NW', min: 303.75, max: 326.25 },
      { name: 'NNW', min: 326.25, max: 348.75 }
    ]
  }
}
